import * as React from "react";
import {classNames, IconNames, layout, typography, useAsync, useFlag} from "@variocube/cube-ui";
import {SupportInfo} from "./controller/Controller";
import {AwesomeBarDropdown} from "./AwesomeBarDropdown";
import {AwesomeBarItem} from "./AwesomeBarItem";
import * as QRCode from "qrcode";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface SupportInfoViewProps {
    supportInfo?: SupportInfo
}
export function SupportInfoView({supportInfo}: SupportInfoViewProps) {
    const {operatedBy, phone, email, website, freetext} = supportInfo ?? {};
    const {t} = useLocalization();
    const [open, setOpen, clearOpen] = useFlag(false);

    const websiteQR = useAsync(async () => website &&
                     QRCode.toDataURL(website, {margin: 1,  scale: 8}), [website]);
    return (
        <>
            {(operatedBy || phone || email || website || freetext) && (
                <AwesomeBarDropdown
                    open={open}
                    onClose={clearOpen}
                    button={<AwesomeBarItem startIcon={IconNames.contact_support} label={t("Support")} onClick={setOpen}/>}
                    alignContent="left"
                >
                    <div className={classNames(layout.horizontal, layout.center, styles.panel)}>
                        <div className={layout.paddingLarge}>
                            {operatedBy && (
                                <div className={classNames(layout.marginYMedium, typography.title)}>{operatedBy}</div>
                            )}
                            {phone && (
                                <div>{phone}</div>
                            )}
                            {email && (
                                <div>{email}</div>
                            )}
                            {website && (
                                <div>{website}</div>
                            )}
                            {freetext && (
                                <div className={classNames(styles.freetext, layout.marginYMedium)}>{freetext}</div>
                            )}
                        </div>
                        {websiteQR.result && (
                            <div className={classNames(layout.paddingLarge)}>
                                <img src={websiteQR.result} alt={website}/>
                            </div>
                        )}
                    </div>
                </AwesomeBarDropdown>
            )}
        </>
    );
}

const styles = stylesheet({
    panel: {
        background: "#222",
    },
    freetext: {
        whiteSpace: "pre-line"
    }
});